const types = {
  SET_AUDIT_LOGS: 'SET_AUDIT_LOGS',
  CLEAR_AUDIT_LOGS: 'CLEAR_AUDIT_LOGS',
  SET_FILTERS: 'SET_FILTERS',
  CLEAR_FILTERS: 'CLEAR_FILTERS',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  CLEAR_CURRENT_PAGE: 'CLEAR_CURRENT_PAGE',
  SET_SORT: 'SET_SORT',
  CLEAR_SORT: 'CLEAR_SORT',
  SET_TOTAL_PAGES: 'SET_TOTAL_PAGES',
  SET_TOTAL_ITEMS: 'SET_TOTAL_ITEMS',
  SET_LIMIT: 'SET_LIMIT',
}

export default types
